import { createContext, ReactNode } from 'react';
import { CompanyDto } from 'tdc-web-backend/companies/schemas';
import useAuth from '../hooks/useAuth';
import useReferenceOne from '../hooks/crud-hooks/useReferenceOne';

interface IUserCompanyContextValue {
  userCompany: CompanyDto | null;
}

export const UserCompanyContext = createContext<IUserCompanyContextValue>({
  userCompany: null,
});

interface IUserCompanyProviderProps {
  children: ReactNode;
}

export const UserCompanyProvider = ({ children }: IUserCompanyProviderProps) => {
  const {
    authData: { userData },
  } = useAuth();

  const { data: companyData } = useReferenceOne<CompanyDto>({
    resource: 'companies',
    id: userData?.membership?.company,
    enabled: !!userData && !!userData.membership?.company,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    queryFilters: { includeRoles: 'true' },
  });

  const contexValue = { userCompany: companyData ?? null };

  return <UserCompanyContext.Provider value={contexValue}>{children}</UserCompanyContext.Provider>;
};
